module.exports = __webpack_public_path__ + "img/logo7.ab48d938.png";